import { isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Production builds: the configurator logs whole arrays on every selection,
// which is slow with devtools open. (environment.production is true in both
// env files, so isDevMode() is the reliable switch.)
if (!isDevMode()) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
